import { render, staticRenderFns } from "./InviteFromCommunityDialog.vue?vue&type=template&id=3c2dfe7c&scoped=true"
import script from "./InviteFromCommunityDialog.vue?vue&type=script&lang=js"
export * from "./InviteFromCommunityDialog.vue?vue&type=script&lang=js"
import style0 from "./InviteFromCommunityDialog.vue?vue&type=style&index=0&id=3c2dfe7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2dfe7c",
  null
  
)

export default component.exports